import { render, staticRenderFns } from "./businessDetailSeckillOrder.vue?vue&type=template&id=bbce3220&scoped=true"
import script from "./businessDetailSeckillOrder.vue?vue&type=script&lang=js"
export * from "./businessDetailSeckillOrder.vue?vue&type=script&lang=js"
import style0 from "./businessDetailSeckillOrder.vue?vue&type=style&index=0&id=bbce3220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbce3220",
  null
  
)

export default component.exports